import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import {
  PARAM_CATEGORIES_PATH,
  STATUS_TYPE_LIST,
} from "src/app/admin/constants/constants";
import { CategoryService } from "src/app/services/categories.service";
import { Category } from "src/app/models/category";
import { AbstractListController } from "src/app/admin/common/abstract-list.component";
import { CommonModule } from "@angular/common";
import { DataTableComponent } from "src/app/admin/common/data-table/data-table.component";
import {
  TableColumn,
  TableFilter,
} from "src/app/admin/common/data-table/data-table.model";

@Component({
  standalone: true,
  selector: "app-manage-categories",
  templateUrl: "./manage-categories.component.html",
  imports: [CommonModule, DataTableComponent],
})
export class ManageCategoriesComponent extends AbstractListController<
  Category,
  any
> {
  title = "Categories";

  tableColumns: TableColumn[] = [
    {
      field: "featured",
      header: "Featured",
      type: "boolean",
      trueTag: { label: "Si", severity: "success" },
      falseTag: { label: "No", severity: "danger" },
    },
    { field: "category_name", header: "Nome" },
    { field: "seo_url", header: "Seo URL" },
    {
      field: "is_active",
      header: "Attivo",
      type: "boolean",
      trueTag: { label: "Si", severity: "success" },
      falseTag: { label: "No", severity: "danger" },
    },
  ];

  tableFilters: TableFilter[] = [
    { field: "category_name", header: "Nome", type: "string" },
    { field: "seo_url", header: "Seo URL", type: "string" },
    {
      field: "is_active",
      header: "Attivo",
      type: "select",
      options: STATUS_TYPE_LIST,
    },
  ];

  editLink = (row: Category): any[] => [
    "/admin/settings/categories/edit",
    row.id,
  ];

  constructor(
    private categoryService: CategoryService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(
      categoryService,
      confirmationService,
      router,
      route,
      PARAM_CATEGORIES_PATH,
    );
    this.useTableFilters = true;
  }
}
